import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest, PaginationType } from '../../types/pagination';
import { CustomCacheRequest, InfiniteScrollRequest, SortRequest } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { PostTaskRequest } from './tasks-api';
import { baseFetch } from './utils.ts/base-fetch';

export type SchedulerType = {
  id: number;
  title: string;
  description: string;
  start_time: string;
  start_date?: string[];
  is_regular: boolean;
  days_of_week?: boolean[]; //по порядку
  staff_ids: number[];
  created_at: string;
  place_name?: LangType;
  place_id?: number;
};

const baseUrl = `${managerApiUrl}/task-schedule`;

export interface FetchSchedulerListRequest
  extends PaginationRequest,
    SortRequest,
    CustomCacheRequest,
    InfiniteScrollRequest,
    Pick<SchedulerType, 'title' | 'description' | 'start_time' | 'created_at'> {
  place_ids: number[];
  employee: string;
}

export const fetchScheduleList = async (
  params: Partial<FetchSchedulerListRequest>,
): Promise<PaginationType & { schedule: SchedulerType[] }> => {
  const { customCache, ...other } = params;
  const response = await baseFetch(baseUrl + buildParams(other), { customCache });
  return response;
};

export type PostScheduleRequest = {
  title?: string;
  description?: string;
  start_time: string;
  start_date?: string[];
  is_regular: boolean;
  days_of_week?: boolean[]; //по порядку
} & PostTaskRequest;

export const postSchedule = async (
  params: Partial<PostScheduleRequest>,
): Promise<{ schedule_item: SchedulerType }> => {
  const response = await baseFetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

export type PutScheduleRequest = SchedulerType & PostTaskRequest;

export const putSchedule = async (
  params: Partial<PutScheduleRequest>,
): Promise<{ schedule_item: SchedulerType }> => {
  const response = await baseFetch(baseUrl, {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};

export const deleteSchedule = async (params: string): Promise<{ data: SchedulerType }> => {
  const response = await baseFetch(baseUrl + '/' + params, {
    method: 'DELETE',
  });
  return response;
};
